import type { Locale } from '@simplisafe/ewok'

import * as TE from 'fp-ts/lib/TaskEither'

import { fetchApi } from '@ecomm/data-simplisafe-api'
import type { FetchOptions } from '@ecomm/data-simplisafe-api/lib/fetch-options'
import { pipe } from 'fp-ts/lib/function'

type SubspaceEvent = {
  readonly eventName: string
  readonly eventProperties: Record<string, string>
  readonly eventTime: string
}

export type SubspaceBody = {
  readonly attributes: Record<string, unknown>
  readonly events: readonly SubspaceEvent[]
  readonly locale: Locale
  readonly userData: {
    readonly emailAddress: string
    readonly externalId: string
    readonly leadId?: string
    readonly uid?: string
  }
}

export const subspaceBrazeRequest = (body: SubspaceBody) => {
  const options: FetchOptions = {
    body: JSON.stringify(body),
    headers: {
      Accept: 'application/json',
      'Accept-Language': body.locale,
      'Content-Type': 'application/json'
    },
    method: 'POST',
    endpoint: `/leads/v1/event/capture`,
    baseUrlOverride: process.env['LEADS_SS_API_URL']
  }
  return pipe(
    TE.Do,
    TE.chain(() => fetchApi(options)),
    TE.mapLeft(
      error => new Error('Failed to send Braze request', { cause: error })
    )
  )
}
